var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "product-category-path"
  }, _vm._l((_vm.categories), function(category, index) {
    return _c('span', {
      key: index
    }, [_vm._t("item", [_vm._v("\n      " + _vm._s(category.name) + "\n    ")], {
      category: category
    }), _vm._v(" "), (_vm.isNotLastItem(index)) ? _c('icon', {
      attrs: {
        "name": "chevron-right"
      }
    }) : _vm._e()], 2)
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8fa63db2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ProductCategoryPath.vue
// module id = 2082
// module chunks = 0